import { Link as RouterLink } from 'react-router-dom';
// material
import { experimentalStyled as styled } from '@material-ui/core/styles';
import { Button, Typography, Container } from '@material-ui/core';
// components
import Page from '../components/Page';
//
import { MaintenanceIllustration } from '../assets';
import HomePageContactForm from 'src/components/_external-pages/about/HomePageContactForm';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  minHeight: '100%',
  display: 'flex',
  alignItems: 'center',
  paddingTop: theme.spacing(15),
  paddingBottom: theme.spacing(10)
}));

// ----------------------------------------------------------------------

export default function Maintenance() {
  return (
    <RootStyle title="Contact | skyniche">
      <Container sx={{ textAlign: 'center',mt:-14}}>
        {/* <Typography variant="h3" paragraph>
          Please Contact Us For More Info
        </Typography> */}
        {/* <Typography sx={{ color: 'text.secondary' }}>We are currently working hard on this page!</Typography>

        <MaintenanceIllustration sx={{ my: 10, height: 240 }} /> */}

          <HomePageContactForm />

        {/* <Button variant="contained" size="large" component={RouterLink} to="/">
          Go to Home
        </Button> */}
      </Container>
    </RootStyle>
  );
}
